/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Location } from '@touchplan/common';
import { MatDialog } from '@angular/material/dialog';
import { LocationsApi } from 'src/app/app-data/state/LocationsApi';
import { AbstractAddEditColorItemComponent } from 'src/app/common/dialog-reusable/components/abstract-add-edit-color-item.component';

@Component({
	selector: 'add-edit-location',
	templateUrl: './add-edit-location.component.html',
	styleUrls: ['./add-edit-location.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEditLocationComponent extends AbstractAddEditColorItemComponent<Location> {
	@Input() public locationsApi: LocationsApi;

	constructor(protected dialog: MatDialog, protected builder: UntypedFormBuilder) {
		super(dialog, builder);
	}

	protected getColorFormControlName() {
		return 'color';
	}

	protected getColorFromModel(location: Location): string {
		return location.view.color ?? null;
	}

	protected valueForFormGroupPatchValue(location: Location, color: string): { [key: string]: any } {
		return {
			name: location.view.name,
			color,
		};
	}
}
